Object.defineProperty(exports, "__esModule", { value: true });
exports.transform = void 0;
const shared = require("@volar/shared");
const locationLike_1 = require("./locationLike");
function transform(locations, getOtherRange) {
    return locations
        .map(location => (0, locationLike_1.transform)(location, getOtherRange))
        .filter(shared.notEmpty);
}
exports.transform = transform;
//# sourceMappingURL=locationsLike.js.map